import { QUICK_FILTER_PAGE_IDS } from "../quickFilterUtils";
import PRODUCT_ANALYTICS_PRESETS from "./productAnalytics";
import CAMPAIGN_LIST_V2_PRESETS from "./campaignListV2";
import TARGETING_V2_PRESETS from "./targetingV2";
import BID_ADJUST_V2_PRESETS from "./bidAdjustV2";
import SEARCH_TERM_V2_PRESETS from "./searchTermV2";

/**
 * Page → platform → system quick filters.
 * Replace per-page/platform files with real rules when ready.
 */
export const SYSTEM_QUICK_FILTER_PRESETS_BY_PAGE = {
  [QUICK_FILTER_PAGE_IDS.PRODUCT_ANALYTICS]: PRODUCT_ANALYTICS_PRESETS,
  [QUICK_FILTER_PAGE_IDS.CAMPAIGN_LIST_V2]: CAMPAIGN_LIST_V2_PRESETS,
  [QUICK_FILTER_PAGE_IDS.TARGETING_V2]: TARGETING_V2_PRESETS,
  [QUICK_FILTER_PAGE_IDS.BID_ADJUST_V2]: BID_ADJUST_V2_PRESETS,
  [QUICK_FILTER_PAGE_IDS.SEARCH_TERM_V2]: SEARCH_TERM_V2_PRESETS,
};

export const getSystemQuickFilters = (
  pageId = QUICK_FILTER_PAGE_IDS.PRODUCT_ANALYTICS,
  platform = "amazon"
) => {
  const normalizedPlatform = `${platform}`.toLowerCase();
  const pagePresets = SYSTEM_QUICK_FILTER_PRESETS_BY_PAGE[pageId];
  if (!pagePresets) return [];

  const platformPresets =
    pagePresets[normalizedPlatform] ?? pagePresets.amazon ?? [];

  return typeof platformPresets === "function"
    ? platformPresets()
    : platformPresets;
};
